import IconButton from 'components/@extended/IconButton';
import { PlayArrow as PlayArrowIcon, PlayCircle as PlayCircleIcon } from 'components/icons';
import { GLYPH_OWN_SIZE } from 'components/buttons/buttonStyle';
import { Button } from 'components/ui/button';
import { cn } from 'utils/cn';
import { Tooltip } from 'components/ui/tooltip';
import { t } from 'utils/getTranslations';

type Props = {
    isDrawerOpen: boolean;
    toggleDrawer: () => void;
    ref?: React.Ref<HTMLButtonElement>;
};

export default function StartTrackingButton({ isDrawerOpen, toggleDrawer, ref }: Props) {
    if (isDrawerOpen) {
        return (
            <Button
                ref={ref}
                size="lg"
                onClick={toggleDrawer}
                className={cn(
                    'bg-grey-0 text-grey-900 hover:bg-info hover:text-primary-foreground group w-full text-sm shadow-sm',
                    GLYPH_OWN_SIZE
                )}
            >
                <PlayCircleIcon className="text-info group-hover:text-primary-foreground" />
                {t('timecards.start-tracking')}
            </Button>
        );
    }

    return (
        <Tooltip content={t('timecards.start-tracking')}>
            <IconButton
                ref={ref}
                onClick={toggleDrawer}
                variant="contained"
                color="info"
                shape="rounded"
                aria-label={t('timecards.start-tracking')}
                className="size-8"
            >
                <PlayArrowIcon className="text-primary-foreground" />
            </IconButton>
        </Tooltip>
    );
}
